import { ISolicitacao } from '@/@types/Protocolo/Solicitacoes';
import { DetalhesSolicitacaoComponent } from '@/components/PagesComponents/DetalhesSolicitacao';
import { api } from '@/services/api';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';


const DetalhesSolicitacao = () => {

    const [detalhesSolicitacaoData, setDetalhesSolicitacaoData] = useState<ISolicitacao>({} as ISolicitacao);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const { id } = useParams();

    useEffect(() => {
        // busca a solicitação por id
        setIsLoading(true);
        const url = `/protocolo/solicitacoes/${id}`;

        const getDetalhesSolicitacao = async () => {

            await api.get(url)
                .then(response => {
                    console.log(response.data);
                    setDetalhesSolicitacaoData(response.data);
                    setIsLoading(false);
                })
                .catch(err => {
                    console.log(err);
                    setIsLoading(false);
                });
        }

        getDetalhesSolicitacao();
    }, [id]);

    return (
        <DetalhesSolicitacaoComponent data={detalhesSolicitacaoData} isLoading={isLoading} />
    )

}

export { DetalhesSolicitacao };